import { Skeleton } from '@/components/atoms/Skeleton';
import ProdutoHome from '@/components/molecules/ProdutoHome';

import * as S from './styles';
import { ListagemProdutosHomeProps } from '../..';
import Text from '@/components/atoms/Text';
import { registrarEvento } from '@/services/googleAnalytics';
import { theme } from '@/styles/theme';

export default function ListagemProdutosHomeDesktop(
  props: ListagemProdutosHomeProps,
) {
  const { $loading, $produtos, style, $funcaoAdicional } = props;

  return (
    <S.Container style={style}>
      {$loading || !$produtos
        ? Array.from({ length: 6 }).map((item, index) => (
            <Skeleton
              key={`skeleton_${item}_${index}`}
              style={{ width: 185, height: 120, borderRadius: theme.radius[4] }}
            />
          ))
        : $produtos?.map((produto) => (
            <div
              key={produto.id}
              onClick={() => {
                $funcaoAdicional?.();
                registrarEvento('home_clicou_gift_card', {
                  produtoID: produto?.produtoID,
                  produto: produto?.nome,
                });
              }}
            >
              <ProdutoHome {...produto} />
            </div>
          ))}
      {!$loading && $produtos?.length === 0 ? (
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={false}
          $text="Não possuimos produtos nesta categoria."
        />
      ) : null}
    </S.Container>
  );
}
